
import {Component, Mixins, Prop, Vue} from "vue-property-decorator";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import FormDialog from "@/components/dialogs/FormDialog.vue";
import {FaizTuruEntity} from "@/entity/FaizTuruEntity";
import FaizTuruForm from "@/components/forms/FaizTuruForm.vue";
import {HesapSekliLabel} from "@/enum/HesapSekli";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import CACHE_STORAGE_ICW from "sls-cache";

@Component({
  components: {FormDialog, DeleteDialog, FaizTuruForm},
})
export default class FaizTuruList extends Mixins(ObjectInputMixin) {
  @Prop() takipTarihi!: Date;
  hesapSekli = HesapSekliLabel;
  dialog: boolean = false;

  faizDetay:any=[]
  search: string = "";
  headers = [
    {text: "Faiz Adı", align: "start", sortable: false, value: "isim", class: 'my-header-style'},
    {text: "İşlemler", value: "actions", align: 'end', width: '100', class: 'header-actions-style'},
  ];

  items: Array<FaizTuruEntity> = [];
  loading: boolean = false;

  get defaultFaizTuru(){
    return new FaizTuruEntity();
  }

  handleFaizSuccess() {
    this.loadFaizTurleri();
    this.$emit('onSuccess');
  }

  mounted() {
    this.loadFaizTurleri();
  }

  async loadFaizTurleri() {
    try {
      this.loading = true;
      const response = await this.$http.get('/api/v1/faiz-tur-list-paginated', {
        params: {
          page: 1,
          per_page: 1000,
        }
      });
      this.items = Array.isArray(response.data) ? response.data : (response.data?.data || []);
      
      // Cache'i temizle
      const cacheKey = this.$helper.hash("/api/v1/faiz-turu/?takibe_ozel_mi=false");
      CACHE_STORAGE_ICW.set(cacheKey, null, undefined);
    } catch (error) {
      console.error('Faiz türleri yüklenirken hata oluştu:', error);
      this.items = [];
    } finally {
      this.loading = false;
    }
  }

  async loadDetay(item:any){
    let response = await this.$http.get("/api/v1/faiz-oran-list/"+ item.id)
    this.faizDetay = response.data;
    (this.$refs.faizTuruForm as any).localValue.faiz_oranlari = this.faizDetay;
    this.$emit('onSuccess');

  }

  getEditTooltip(item: any) {
    if (!this.$helper.isAuthorized('faiz-turu-duzenle')) {
      return 'Bu işlem için yetkiniz yok.';
    }
    if (item && item.standart_mi) {
      return 'Standart faizler düzenlenemez.';
    }
    return this.$helper.icraSuresiDoldu() ? 'Kullanım süreniz dolduğu için bu işlem yapılamaz.' : '';
  }

  getDeleteTooltip() {
    if (!this.$helper.isAuthorized('faiz-turu-sil')) return 'Bu işlem için yetkiniz yok.';
    return this.$helper.icraSuresiDoldu() ? 'Kullanım süreniz dolduğu için bu işlem yapılamaz.' : '';
  }
}
